import React from 'react'

import * as S from './styled'

const Slider = ({ min = 1, max = 10, step = 1, label, value, onChange }) => {
    return (
        <S.Slider className="form-group">
            {label && <label className="!mb-1">{label}</label>}
            <input type="range" min={min} max={max} step={step} value={value} onChange={onChange} />
        </S.Slider>
    )
}

export default Slider
